import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getTicketNameTextStyles } from 'common/entities/form/styleConfiguration/selectors';
import {
    setTicketNameTextFont,
    setTicketNameTextFontsize,
    setTicketNameTextColor,
} from 'common/entities/form/styleConfiguration/actions';
import { getDefaultStyle, styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';
import {
    DEFAULT_FONT,
    DEFAULT_TICKET_FONT_SIZE,
    DEFAULT_TICKET_NAME_COLOR,
} from 'common/entities/form/styleConfiguration/defaultValues';
import DefaultFontTicketStylePanel from './DefaultFontTicketStylePanel';
import { getFormId, getOpenTicketStylingType } from '../../../../selectors';
import { NAME_QA } from '../../../../constants/ticketDataQa';
import { NAME_LABEL } from '../../../../constants/formStyleLabels';

const FormStyleTicketEditorNamePanel = (props) => (
    <DefaultFontTicketStylePanel
        ticketPanelQaId={NAME_QA}
        setTicketPanelFontFamily={props.setTicketNameTextFont}
        setTicketPanelFontSize={props.setTicketNameTextFontsize}
        setTicketPanelTextColor={props.setTicketNameTextColor}
        {...props}
        componentLabel={NAME_LABEL}
    />
);

FormStyleTicketEditorNamePanel.propTypes = {
    formId: PropTypes.string.isRequired,
    color: styleShapePropTypes,
    font: styleShapePropTypes,
    fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    setTicketNameTextFont: PropTypes.func.isRequired,
    setTicketNameTextFontsize: PropTypes.func.isRequired,
    setTicketNameTextColor: PropTypes.func.isRequired,
};

FormStyleTicketEditorNamePanel.defaultProps = {
    color: getDefaultStyle(DEFAULT_TICKET_NAME_COLOR),
    font: getDefaultStyle(DEFAULT_FONT),
    fontSize: DEFAULT_TICKET_FONT_SIZE,
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const openTicketType = getOpenTicketStylingType(state);

    const { color, font, fontSize } = getTicketNameTextStyles(state, formId, openTicketType);

    return {
        formId,
        color,
        font,
        fontSize,
    };
};

const mapDispatchToProps = {
    setTicketNameTextFont,
    setTicketNameTextFontsize,
    setTicketNameTextColor,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormStyleTicketEditorNamePanel);
